import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Services } from './../services-url';

@Injectable({
  providedIn: 'root'
})
export class GoodPracticesService {

  constructor(
    private http: HttpClient,
  ) { }

  getPractices():Observable<any>{
    return this.http.get(Services.goodPractices).pipe(
      tap(publications => console.info(`fetched practice`))
    );
  }

  getPracticeDetails(token:string):Observable<any>{
    return this.http.get(`${Services.goodPractice}/${token}`).pipe(
      tap(posts => console.info(`fetched practice`))
    );
  }
}
